/**
 * Central brand configuration. Change BRAND_NAME here to rebrand the entire
 * customer-facing SaaS in one place (landing, nav, footer, emails, titles, etc.)
 * Keep this file small — only identity & contact. Plans live in /plans.js.
 */
export const BRAND = {
  name: "BRAND_NAME",
  tagline: "Cinematic streaming, anywhere you are.",
  // Domain & contact
  domain: "brand-name.tv",
  supportEmail: "support@brand-name.tv",
  // Social (UI uses these only if non-empty)
  social: {
    twitter: "",
    instagram: "",
    discord: "",
  },
  // Logo / icon — if you later ship an SVG, point these to assets
  logo: {
    // Pure text-based lockup by default
    text: "BRAND_NAME",
  },
  // Optional badge shown in nav (e.g. "beta", "v1")
  badge: "beta",
};
